import { SECTION_NAMES } from '@repo/common';

/**
 * Sections that show another section's icon instead of their own.
 *
 * New Releases reuses the New Games icon, and a jackpot's Boost and VIP sections use their family's
 * icon (Bell Link, High Cash, Gods & Kings). Pointing them all at the family's file keeps it to one
 * URL, so the SVG sprite fetches and keeps it once for every section header and footer tab of that
 * family, instead of once per section.
 */
const SECTION_ICON_ALIASES: Partial<Record<string, string>> = {
  [SECTION_NAMES.NEW_REL]: SECTION_NAMES.NEW_GAMES,
  [SECTION_NAMES.BELL_LINK_BOOST]: SECTION_NAMES.BELL_LINK,
  [SECTION_NAMES.VIP_BELL_LINK]: SECTION_NAMES.BELL_LINK,
  [SECTION_NAMES.VIP_BELL_LINK_BOOST]: SECTION_NAMES.BELL_LINK,
  [SECTION_NAMES.VIP_HIGH_CASH]: SECTION_NAMES.HIGH_CASH,
  [SECTION_NAMES.VIP_GODS_AND_KINGS]: SECTION_NAMES.GODS_AND_KINGS,
};

export const getSectionIconBaseName = (sectionName: string): string =>
  (SECTION_ICON_ALIASES[sectionName] ?? sectionName)?.toLowerCase();
